module.exports = __webpack_public_path__ + "static/media/hanukiah.0d1c1e99.svg";